module.exports = __webpack_public_path__ + "static/media/2.0c05b887.jpg";